@if (model$ | async; as model) {
  <app-uig-card
    i18nRoot="orgUser.details"
    [cxFocus]="{ refreshFocus: model }"
    >
    <a
      actions
      class="link change-password"
      [class.disabled]="!model.active || (isInEditMode$ | async)"
    [routerLink]="
      { cxRoute: 'orgUserChangePassword', params: model } | cxUrl
    "
      >
      {{ 'orgUser.links.password' | cxTranslate }}
    </a>
    <a
      actions
      class="link edit"
      [class.disabled]="!model.active || (isInEditMode$ | async)"
      [routerLink]="{ cxRoute: 'orgUserEdit', params: model } | cxUrl"
      >
      {{ 'organization.edit' | cxTranslate }}
    </a>
    <app-uig-user-toggle-status
      actions
      key="uid"
      i18nRoot="uigOrgUser"
    ></app-uig-user-toggle-status>
    <app-uig-delete-toggle-status
      actions
      key="uid"
      i18nRoot="uigOrgUser"
    ></app-uig-delete-toggle-status>
    <cx-org-disable-info info i18nRoot="orgUser"> </cx-org-disable-info>
    <section main class="details" cxOrgItemExists>
      <div class="property">
        <label>{{ 'orgUser.title' | cxTranslate }}</label>
        <span class="value">
          {{ model.title }}
        </span>
      </div>
      <div class="property">
        <label>{{ 'orgUser.name' | cxTranslate }}</label>
        <span class="value">
          {{ model.name }}
        </span>
      </div>
      <div class="property">
        <label>{{ 'orgUser.uid' | cxTranslate }}</label>
        <span class="value">
          {{ model.uid }}
        </span>
      </div>
      <div class="property full-width">
        <label>{{ 'orgUser.email' | cxTranslate }}</label>
        <span class="value">
          {{ model.email }}
        </span>
      </div>
      @if (model.orgUnit?.name) {
        <div class="property">
          <label>{{ 'orgUser.orgUnit' | cxTranslate }}</label>
          <a
            class="value"
        [routerLink]="
          {
            cxRoute: 'orgUnitDetails',
            params: model.orgUnit
          } | cxUrl
        "
            >
            {{ model.orgUnit?.name }}
          </a>
        </div>
      }
      @if (model.defaultAddress) {
        <div class="property full-width">
          <label>{{ 'orgUser.deliveryAddress' | cxTranslate }}</label>
          <span class="value">
            <div>{{ model.defaultAddress.companyName }}</div>
            <div>{{ model.defaultAddress.line1 }}</div>
            <div>{{ model.defaultAddress.postalCode }} {{ model.defaultAddress.town }}</div>
            <div>{{ model.defaultAddress.country?.name }}</div>
          </span>
        </div>
      }
      @if (model.preferredDeliveryMode) {
        <div class="property full-width">
          <label>{{ 'orgUser.standardShippingMethod' | cxTranslate }}</label>
          <span class="value">
            <div>{{ model.preferredDeliveryMode.name }}</div>
          </span>
        </div>
      }
    </section>
    @if (accessSubjectOverviewData) {
      <section main class="details">
        <h5 class="heading">{{ 'orgUser.permission.title' | cxTranslate }}:</h5>
        <fieldset aria-required="true" class="full-width" formArrayName="roles">
          @for (item of accessSubjectOverviewData.ringfotoAccessSubjects; track item) {
            <div class="property full-width">
              <label>{{ item.name }}</label>
              @if (item.multiplePermissions) {
                @if (item.allowedPermissions) {
                  <fieldset class="row">
                    @for (allowedPermission of item.allowedPermissions; track allowedPermission) {
                      @if (addCheckboxPlaceholder(item.allowedPermissions[0])) {
                        <label class="form-check col-6"></label>
                      }
                      <label class="form-check col-6">
                        <input type="checkbox"
                          class="form-check-input"
                          [value]="allowedPermission.uid"
                          [checked]="userRoles?.includes(allowedPermission.uid)"
                          disabled="true" />
                          <span class="form-check-label">
                            {{ allowedPermission.label }}
                          </span>
                        </label>
                      }
                    </fieldset>
                  }
                } @else {
                  <span class="value">
                    {{ getAllowedPermission(item.code) }}
                  </span>
                }
              </div>
            }
          </fieldset>
        </section>
      }
    </app-uig-card>
  }
